import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { style } from "../../../components/pdf/fontstyles";
import { AutoText } from "../../../components/pdf/autoText";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    marginLeft: 40,
    marginTop:40,
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 30, // Left and Right Margins for clean print layout
    fontSize: 10,
    ...style.marathi,
  },
  header: {
    textAlign: "center",
    marginBottom: 12,
    fontSize: 18,
    fontWeight: "bold",
    textDecoration: "underline",
  },
  table: {
    display: "table",
    width: "100%", // maximize table within margins
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
    textAlign: "center",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    textAlign: "center",
  },
  col1: { width: "3%" },
  col2: { width: "7%" },
  col3: { width: "5%" },
  col4: { width: "8%" },
  col5: { width: "8%" },
  col6: { width: "7%" },
  col7: { width: "9%" },
  col8: { width: "7%" },
  col9: { width: "9%" },
  col10: { width: "9%" },
  col11: { width: "7%" },
  col12: { width: "12%" },
  col13: { width: "10%" },
  col14: { width: "9%" },
  col15: { width: "9%" },
});


const Praptar2 = ({ result }) => (
  <View size="A4" style={styles.page}> 
      <View style={styles.header}>
        <Text>प्रपत्र २</Text>
      </View>
      
      <View style={{marginBottom: 5}}>
        <Text>{`<<Name of the office>>`}</Text>
      </View>

      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={[styles.tableColHeader, styles.col1]}>
            <Text>अ क्र</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col2]}>
            <Text>कर्मचाऱ्याचे नाव</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col3]}>
            <Text>हुद्दा</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col4]}>
            <Text>शैक्षणिक पात्रता</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col5]}>
            <Text>मूळ नेमणूक दिनांक</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col6]}>
            <Text>वेतन श्रेणी</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col7]}>
            <Text>बी एड वेतनश्रेणी लागू करण्यात आलेला दिनांक</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col8]}>
            <Text>सध्या लागू असलेला सुधारित वेतन स्तर</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col9]}>
            <Text>सुधारित वेतन स्तरामधील ०१/०१/२०१६ चे वेतन</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col10]}>
            <Text>एकाच वेतन श्रेणीत १२ वर्षे पूर्ण झालेला दिनांक</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col11]}>
            <Text>देय वरिष्ठ वेतन स्तर</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col12]}>
            <Text>वरिष्ठ वेतन स्तरा मधील पात्र दिनांकास निश्चित केलेले वेतन व वेतनवाढ दिनांक</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col13]}>
            <Text>पुढील वेतन वाढ दिनांक</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col14]}>
            <Text>मूळ नेमणूकी पासून सेवाखंडचा कालावधी</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col15]}>
            <Text>शेरा</Text>
          </View>
        </View>

        {/* Table Row */}
        <View style={styles.tableRow}>
          <View style={[styles.tableCol, styles.col1]}>
            <Text>१</Text>
          </View>
          <View style={[styles.tableCol, styles.col2]}>
            <Text>{result.employeeName}</Text>
          </View>
          <View style={[styles.tableCol, styles.col3]}>
            <Text>{result.designation}</Text>
          </View>
          <View style={[styles.tableCol, styles.col4]}>
            <Text>{result.education}</Text>
          </View>
          <View style={[styles.tableCol, styles.col5]}>
            <Text>{result.dateOfJoining}</Text>
          </View>
          <View style={[styles.tableCol, styles.col6]}>
            <Text>{result.payBand}</Text>
            <Text>{result.gradePay}</Text>
          </View>
          <View style={[styles.tableCol, styles.col7]}>
            <Text>{result.payBand}</Text>
            <Text>{result.gradePay}</Text>
          </View>
          <View style={[styles.tableCol, styles.col8]}>
            <Text>{`<<Revised Pay Level in 7th Pay>>`}</Text>
          </View>
          <View style={[styles.tableCol, styles.col9]}>
            <Text>{`<<Pay Fixed as on 01/01/2016 in Pay Matrix>>`}</Text>
          </View>
          <View style={[styles.tableCol, styles.col10]}>
            <Text>{result.dateOfPromotion}</Text>
            <Text>विकल्प दिनांक :</Text>
            <Text>{result.dateOfOption}</Text>
          </View>
          <View style={[styles.tableCol, styles.col11]}>
            <Text>{result.payBandPromotion}</Text>
            <Text>{result.gradePayPromotion}</Text>
          </View>
          <View style={[styles.tableCol, styles.col12]}>
            <Text>{`<<PAY FIXED IN SR LEVEL>>`}</Text>
          </View>
          <View style={[styles.tableCol, styles.col13]}>
            <Text></Text>
          </View>
          <View style={[styles.tableCol, styles.col14]}>
            <Text>निरंक</Text>
          </View>
          <View style={[styles.tableCol, styles.col15]}>
            <Text>काही नाही</Text>
          </View>
        </View>
      </View>
  </View>
);

export default Praptar2;